import { ReactElement } from 'react';

import { MedicalDocumentSimple, MedicalDocumentSimpleQuery } from '@dreryk/egabinet-document-repository-frontend-api';

import {
   ConfidentialAccessPendingButton,
   ConfidentialAccessRequestButton,
} from '~libs.desktop.shared.medical-data-confidentiality';

import { DownloadMedicalDocumentLink } from './DownloadMedicalDocumentLink';
import { mapMedicalDocumentTypeToConfidentialResourceType } from './confidentialResourcesAccess/confidentialResourceAccess.utils';

type ActionsCellProps = {
   readonly medicalDocument: MedicalDocumentSimple;
};

const ActionsCell = (props: ActionsCellProps): ReactElement => {
   const { medicalDocument } = props;

   if (!medicalDocument.confidential) {
      return <DownloadMedicalDocumentLink url={medicalDocument.url} />;
   }

   if (medicalDocument.pendingVisitConfidentialAccess) {
      return <ConfidentialAccessPendingButton />;
   }

   return (
      <ConfidentialAccessRequestButton
         resourceId={medicalDocument.id}
         resourceType={mapMedicalDocumentTypeToConfidentialResourceType(props.medicalDocument.documentType.code)}
         refetchQuery={MedicalDocumentSimpleQuery}
      />
   );
};

export { ActionsCell };
